import { render } from "./ZaloTemplate.vue?vue&type=template&id=2f7764f1&scoped=true"
import script from "./ZaloTemplate.vue?vue&type=script&lang=js"
export * from "./ZaloTemplate.vue?vue&type=script&lang=js"

import "./ZaloTemplate.vue?vue&type=style&index=0&id=2f7764f1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7764f1"]])

export default __exports__